import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { SiteHeader } from "../../components/header/header";
import { brands, categories } from "../../_helpers/mock-data";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { filterData, searchData } from "../../_helpers/filters";

import { useProduct } from "../../../services/products/product.context";
import { ItemUpdateCard } from "../../components/containers/update-card";
import { UpdateSearchForm } from "../../components/forms/update-search";
import { AppAlert } from "../../components/utils/alert";
import { useAuthentication } from "../../../services/authentication/authentication.context";
import { FooterComponent } from "../../components/footer/footer";


export const ProductUpdate = () => {
    const navigateTo = useNavigate();

    const { getProductsByBatch, deleteProduct } = useProduct();
    const { token } = useAuthentication();


    const [brand, setBrand] = useState('All');
    const [category, setCategory] = useState('All');
    const [filtering, setFiltering] = useState(false);
    const [onAlert, setOnAlert] = useState();
    const [searchRes, setSearchRes] = useState();
    const [products, setProducts] = useState([]);


    useEffect(() => {
        (async () => {
            const resp = await getProductsByBatch();
            const data = resp?.data;
            //console.log({data})
            const resp1 = filterData(brand, category, data);
            //console.log(resp1);
            setProducts(resp1);
            if (searchRes) {
                const resp2 = searchData(searchRes, data);
                setProducts(resp2);
                return;
            }
            //console.log({products})
        })();
    }, [brand, category, products, searchRes]);

    const handlePromptDeletion = (product) => {
        setOnAlert({
            caption: 'Delete Product',
            message: `Do you wish to permanently delete data for ${product?.designation}? This action is irreversible!`,
            accept: "Delete",
            reject: "Cancel",
            onAccept: async () => {
                await deleteProduct(product?._id, product?.images, token)
                setOnAlert();
            },
            onReject: () => setOnAlert()
        })
    }

    return (
        <div className="app-body">
            <SiteHeader pageTitle={'CATEGORIES'} />
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    reject={onAlert.reject}
                    onClose={() => setOnAlert()}
                    onAcept={onAlert.onAccept}
                    onReject={onAlert.onReject}
                />
            )}
            <div className="page-titles">
                <div className="thin-text f-hero">Update/Delete a product</div>
                <div className="slogan-1">
                    {brand !== "All" ? brand : (category !== "All" ? category : 'All Products')}
                </div>
            </div>
            <div className="filter-button-box">
                <button
                    className="filter-button"
                    onClick={() => setFiltering(true)}
                >
                    <img src="/svgs/filter-sort.svg" alt="" className="sm-svg" />
                    <span className="sm-caption">Filters</span>
                </button>
            </div>
            <UpdateSearchForm
                onSearch={(v) => setSearchRes(v)}
                handleCancel={() => setSearchRes()}
            />
            <div className="prod-section">
                <div className={classNames("filter-section", { 'slide-down': filtering })}>
                    <div className="filter-button-box close-box">
                        <button
                            className="filter-button close-button"
                            onClick={() => setFiltering(false)}
                        >
                            <FontAwesomeIcon icon={faClose} />
                        </button>
                    </div>
                    <div className="filter-group">
                        <div className="filter-caption">Category</div>
                        <div className="filter-list">
                            <button
                                className={classNames("br-button", { 'sel': category === "All" })}
                                onClick={() => {
                                    setCategory("All");
                                    const res = filterData(brand, "All", products);
                                    setProducts(res);
                                    setFiltering(false);
                                }}
                            >
                                {"All"}
                            </button>
                            {categories.map((cat, k) => (
                                <button
                                    className={classNames("br-button", { 'sel': category === cat.name })}
                                    onClick={() => {
                                        setCategory(cat.name);
                                        const res = filterData(brand, cat.name, products);
                                        setProducts(res);
                                        setFiltering(false);
                                    }}
                                    key={k}
                                >
                                    {cat.name}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="filter-group">
                        <div className="filter-caption">Brands</div>
                        <div className="filter-list">
                            <button
                                className={classNames("br-button", { 'sel': brand === "All" })}
                                onClick={() => {
                                    setBrand("All");
                                    const res = filterData("All", category, products);
                                    setProducts(res);
                                    setFiltering(false);
                                }}

                            >
                                {"All"}
                            </button>
                            {brands.map((br, k) => (
                                <button
                                    className={classNames("br-button", { 'sel': brand === br.name })}
                                    onClick={() => {
                                        setBrand(br.name);
                                        const res = filterData(br.name, category, products);
                                        setProducts(res);
                                        setFiltering(false);
                                    }}
                                    key={k}
                                >
                                    {br.name}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
                <div className="filtered-products">
                    <div className="slogan-1">
                        {brand !== "All" ? "Brand Products" : "Products"}
                    </div>
                    <div className="thin-text sp-3-st">
                        {(brand !== "All" || category !== "All" || searchRes)
                            && products?.length + " products found"
                        }

                    </div>
                    {products?.length === 0 ?
                        <div className="no-product sp-3-st">
                            <div className="slogan-2">No Products to display</div>
                        </div> :
                        <div className="catalog">
                            {products?.map((item) => (
                                <ItemUpdateCard
                                    key={item?._id}
                                    onUpdate={() => navigateTo("/updateproduct", { state: item })}
                                    onDelete={() =>  handlePromptDeletion(item)}
                                    item={item}
                                    onClick={() => navigateTo("/details", { state: item })}
                                />
                            ))}
                        </div>
                    }
                </div>          
            </div>
             <FooterComponent />
        </div>
    )
}